<template>
  <div id="app">
    <FormAssidai msg=""/>
  </div>
</template>

<script>
import FormAssidai from './components/FormAssidai.vue'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

export default {
  name: 'app',
  components: {
    FormAssidai
  }
}
</script>

<style>


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(255, 120, 55);
  margin-top: 60px;
}
</style>
